import { customFetch } from "../utils/http";

export const postLogin = async (email: string, password: string) => {
  return await customFetch("v1/auth/login", {
    method: "POST",
    body: JSON.stringify({ email, password }),
  });
};


export const getProfile = async () => {
  return await customFetch("v1/auth/profile", { method: "GET" });
};

export const getProfileByToken = async (token: string) => {
  return await customFetch("v1/auth/profile", { method: "GET" },false, false, token);
};

export const getVerificationEmail = async (token: string) => {
  return await customFetch("v1/auth/verification-email/" + token,  { method: "GET" });
};


export const updatePushToken = async (data: any) => {
  return await customFetch("v1/auth/update-push-token", {
    method: "PUT",
    body: JSON.stringify(data),
  });
};
